module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e227622"
    }
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Meye_9781621369127_epub_c3_r1#d6e4",
      "id": "d7e4"
    }
  }, [_vm._v("CAPÍTULO 2")])]), _vm._v(" "), _c('p', {
    staticClass: "h",
    attrs: {
      "id": "d7e228122"
    }
  }, [_c('a', {
    staticClass: "calibre4",
    attrs: {
      "href": "#/Text/Meye_9781621369127_epub_c3_r1#d6e4",
      "id": "d14e435"
    }
  }, [_vm._v("Entender por qué uno hace"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\n  lo que hace")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "d7e228922"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("U")]), _vm._v("na vez oí una historia sobre un farero que trabajaba en una parte escarpada de la costa. Una vez al mes, el farero recibía nuevas provisiones de aceite para mantener encendido el faro, a fin de que los barcos pudieran navegar con seguridad cerca de la rocosa costa. Una noche, sin embargo, una mujer de una aldea cercana acudió a él y le suplicó que le diera algo de aceite para mantener caliente a su familia. En otra ocasión, un padre le pidió que le diera un poco para utilizarlo en su lámpara; otro hombre necesitaba lubricar una rueda. Ya que todas las peticiones parecían ser legítimas, el farero intentó agradar a todos ellos y les concedió todas sus peticiones.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e232522"
    }
  }, [_vm._v("Para el final del mes, el hombre observó que su provisión de aceite era peligrosamente baja. Poco tiempo después, se le terminó, y una noche la luz del faro se apagó y, como resultado, aquella noche varios barcos naufragaron y se perdieron incontables vidas. Cuando las autoridades investigaron, el hombre se mostró lleno de disculpas; les dijo que solamente trataba de ayudar con el aceite, sin embargo, la respuesta que ellos dieron a sus excusas fue sencilla y concreta: “A usted se le dio el aceite con un propósito, y sólo un propósito: ¡mantener encendida esa luz!”."), _c('sup', {
    staticClass: "calibre6"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Meye_9781621369127_epub_c24_r1#d2",
      "id": "a2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d14e449"
    }
  }, [_vm._v("¿Cuándo fue la última vez que tomaste un minuto para pensar acerca de por qué haces lo que haces? ¿Qué es lo que guía tus elecciones, tu toma de decisiones, y lleva a cabo tus actos? ¿Estás haciendo lo que debes estar haciendo? ¿Y lo estás haciendo con anhelo y dedicación?")]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "d7e239423"
    }
  }, [_vm._v("¿Cuándo fue la última vez que tomaste un minuto para pensar acerca de por qué haces lo que haces?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e240623"
    }
  }, [_vm._v("Es triste decirlo, pero la mayoría de las personas nunca se detienen el tiempo suficiente para preguntarse por qué hacen lo que hacen, pero ese es uno de los principales intereses de Dios. En realidad, Él no se impresiona por lo que hacemos, sino más bien está interesado en “por qué” lo hacemos. Las buenas obras hechas con motivos equivocados no recibirán ninguna recompensa cuando estemos delante de Dios el día del juicio.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e243223"
    }
  }, [_vm._v("“Él sacará a la luz lo que está oculto en la oscuridad y pondrá al descubierto las intenciones de cada corazón. Entonces cada uno recibirá de Dios la alabanza que le corresponda.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e244923"
    }
  }, [_vm._v("—1 CORINTIOS 4:5b")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e245423"
    }
  }, [_vm._v("En ese día, todo hombre y toda mujer darán cuentas de sí mismos (ver Romanos 14:12). Esta es una idea que da qué pensar, y uno debería contemplarla con seriedad. Quienes hayan puesto su fe en Jesús y lo hayan recibido como Salvador no serán juzgados con respecto a la salvación—sus nombres ya están escritos en el Libro de la Vida del Cordero—sino que serán juzgados con respecto a sus obras hechas durante el tiempo que estuvieron en la tierra y serán recompensados según hayan sido.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e248123"
    }
  }, [_vm._v("La Biblia nos enseña que todas las obras hechas por un motivo incorrecto (maldad, egoísmo) serán quemadas, y la recompensa de ellas se perderá (ver 1 Corintios 3:13–15). Deberíamos asegurarnos de conocer cuáles son nuestros motivos.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e249623"
    }
  }, [_vm._v("Es posible conocer el propósito de tu vida y pasar tu vida haciéndolo con un motivo incorrecto en tu corazón. Por ejemplo, yo sé que parte de mi propósito en la vida es enseñar la Palabra de Dios por todo el mundo. En los primeros años de mi ministerio, Dios tuvo que reprenderme severamente porque, aunque estaba siguiendo mi propósito, mis motivos no eran los correctos. Yo quería ser importante, que pensaran bien de mí y me admirasen; buscaba encontrar mi valía en lo que hacía, cuando debería haberla encontrado en ser hija de Dios y saber quién era yo en Cristo.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e253124"
    }
  }, [_vm._v("Las cosas no iban correctamente en mi vida; mi ministerio no progresaba, y yo no era feliz. Me sentía frustrada la mayor parte del tiempo y no tenía paz ni gozo; sabía que algo iba mal. Yo pensaba que el diablo me estaba obstaculizando, y entonces Dios me mostró que lo que me obstaculizaba eran mis motivos. Yo oraba mucho tiempo y con fuerza cada día, pero Dios no podía responder mis oraciones, porque mis motivos no eran correctos.")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e255824"
    }
  }, [_vm._v("“Y cuando piden, no reciben porque piden con malas intenciones, para satisfacer sus propias pasiones.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e256624"
    }
  }, [_vm._v("—SANTIAGO 4:3")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e257124"
    }
  }, [_vm._v("Cuando comprendí que mi corazón no era correcto, tomé la decisión de vivir para Dios y para su gloria, y no para mí misma y mi gloria. Es posible cambiar nuestro motivo simplemente tomando una decisión, pero antes debemos saber cuáles son nuestros motivos y propósitos, y eso requiere que hagamos un profundo examen de corazón para el que pocas personas están dispuestas a tomarse el tiempo. Con bastante frecuencia, tenemos temor a conocernos realmente a nosotros mismos; una persona valiente es la que afronta la verdad sobre sí misma y hace todo lo que sea necesario para alinearse con la voluntad de Dios. Te reto a que seas lo bastante valiente para examinar sinceramente todos tus motivos y estar dispuesto a no hacer nada si no puedes hacer algo por las razones correctas.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d7e261324"
    }
  }, [_c('b', {
    staticClass: "calibre7"
  }, [_vm._v("Tienes que atreverte")])]), _vm._v(" "), _c('p', {
    staticClass: "h4a",
    attrs: {
      "id": "d7e261824"
    }
  }, [_c('i', {
    staticClass: "calibre8"
  }, [_vm._v("Comprueba cuáles son tus motivos")])]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "d7e262424"
    }
  }, [_vm._v("Una de las mejores cosas que podemos hacer por nuestro caminar espiritual es sentarnos y tomar tiempo para pensar acerca de por qué hacemos lo que hacemos. Cuanto más entendamos cuáles son nuestros verdaderos motivos, mejor podemos trabajar para asegurarnos de que nuestro propósito esté en línea con el de Dios. Hazte estas preguntas y, cuando pienses en tus respuestas, escríbelas en un cuaderno o un diario para que puedas repasarlas periódicamente.")]), _vm._v(" "), _c('p', {
    staticClass: "exta",
    attrs: {
      "id": "d7e265725"
    }
  }, [_vm._v("Pide a Dios que te ayude a sintonizar mejor tus motivos para que Él pueda usarte plenamente.")]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "d7e266525"
    }
  }, [_vm._v("1. Cuando piensas en hacer algo para Dios, ¿qué esperas sacar de ello?")]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "d7e267825"
    }
  }, [_vm._v("2. Cuando les dices a otros lo que estás haciendo por Dios, ¿esperas en secreto que ellos te admiren?")]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "d7e268825"
    }
  }, [_vm._v("3. ¿Cuánto estás dispuesto a sacrificarte para hacer la voluntad de Dios?")]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "d7e270125"
    }
  }, [_vm._v("4. ¿Te encuentras a ti mismo haciendo más de lo que parece que puedes manejar solamente para agradar a los demás?")]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "d7e271725"
    }
  }, [_vm._v("5. ¿Oras antes y luego haces planes, o planeas primero y luego oras para que tus planes salgan adelante?")]), _vm._v(" "), _c('p', {
    staticClass: "ext2",
    attrs: {
      "id": "d7e272925"
    }
  }, [_vm._v("6. ¿Estás dispuesto a dejar de hacer algo si Dios te muestra que es momento de pasar a otra cosa?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e274425"
    }
  }, [_vm._v("Para ser sincera, yo quedé horrorizada cuando comprendí que muchos de mis propósitos y motivos eran incorrectos. Fue difícil para mí afrontarlo, pero por la gracia de Dios lo hice, y eso fue un importante punto de inflexión en mi vida. Dios me enseñó al principio de mi caminar con Él por qué es tan importante conocer y entender nuestros motivos, y te recomiendo encarecidamente que te tomes algún tiempo para examinar tu alma y saber cuál es el “porqué” que está detrás de lo que haces.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e277325"
    }
  }, [_vm._v("Factores motivadores")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e277825"
    }
  }, [_vm._v("Enumera algunas de las cosas que te motivan para hacer lo que haces. Todo el mundo las tiene: esas fuerzas o personas que nos impulsan hacia delante o nos hacen emprender la acción con respecto a algo. Quizá sea la esperanza de un ascenso en el trabajo o el amor de nuestros hijos lo que nos mantiene avanzando. Algunas personas son motivadas por el aplauso o la aprobación de los amigos, familiares o compañeros de trabajo. Lamentablemente, no todos los motivadores son buenos o agradables a Dios. La avaricia es un poderoso motivador para muchas personas, pero Dios nos advierte del peligro de la avaricia (ver Lucas 12:15). Roba la vida de quienes están motivados por ella.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e282326"
    }
  }, [_vm._v("Algunas personas son motivadas por los celos y la envidia; otras son motivadas por el odio y la amargura. Algunas son motivadas por la venganza y otras por la inseguridad y el temor. Nuestros motivadores son como el combustible en un auto: es la fuerza que nos impulsa. Necesitamos algo que nos motive, que nos mueva a la acción, pero tiene que ser algo que produzca buen fruto en nuestras vidas y en las vidas de otros. Cuando un niño no rinde bien en la escuela, su maestro a menudo dice que no tiene motivación. Quizá el niño no pueda agradar nunca a sus padres a pesar de lo que haga, y por eso ha perdido su motivación para siquiera intentarlo. Quizá no le hayan enseñado una buena ética de trabajo y sea básicamente perezoso; quizá los métodos de enseñanza que se utilizan en su escuela no sean apropiados para su modo de aprender. Algunas personas aprenden fácilmente de libros, mientras que otras necesitan más aplicación práctica. El punto es que cuando las personas no tienen motivación, o tienen una motivación incorrecta, normalmente existe una raíz que hay que localizar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e287626"
    }
  }, [_vm._v("Las personas amargadas y enojadas que buscan venganza han sido heridas, y no han aprendido que Dios es su Redentor. No saben que Él traerá justicia a sus vidas si ellos solamente esperan en Él. Quienes están motivados por los celos y la envidia son individuos inseguros que se comparan a sí mismos y sus vidas con otras personas; piensan que su dignidad y su valor se encuentran en estar por delante de todos los demás. Quienes están motivados por la avaricia buscan poder de una fuente equivocada. Quienes están motivados por el materialismo han olvidado que vinieron a este mundo sin nada y que se irán sin nada.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e291527"
    }
  }, [_vm._v("Por lo tanto, ¿cuáles son algunos buenos motivadores a tener en tu vida? Utiliza esta lista para comenzar, y ve cuáles otros puedes añadir a ella:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e293227"
    }
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("1. El Espíritu de Dios.")]), _vm._v(" “Así que les digo: Vivan por el Espíritu, y no seguirán los deseos de la naturaleza pecaminosa” (Gálatas 5:16). Cuando escuchamos verdaderamente al Espíritu de Dios en nosotros, tenemos el mejor factor motivador posible para guiar nuestros pasos porque la verdad no puede mezclarse con nada menos que la verdad. Deberíamos poder decir que somos motivados por el Espíritu de Dios en lo que hacemos. Hacemos lo que hacemos porque creemos que es la voluntad de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e296627"
    }
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("2. Amor puro.")]), _vm._v(" La carta de Pablo a los filipenses indica que su encarcelamiento reveló las verdaderas motivaciones de la gente, tanto buenas como malas. “Es cierto que algunos predican a Cristo por envidia y rivalidad, pero otros lo hacen con buenas intenciones. Estos últimos lo hacen por amor, pues saben que he sido puesto para la defensa del evangelio. Aquéllos predican a Cristo por ambición personal y no por motivos puros, creyendo que así van a aumentar las angustias que sufro en mi prisión” (Filipenses 1:15–17). El amor genuino es un importante motivador para nuestro propósito y pasión porque con él, el odio, la envidia y la avaricia son difíciles de mantener. Deberíamos poder decir que hacemos lo que hacemos por amor puro.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e300527"
    }
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("3. Fe.")]), _vm._v(" Al igual que Moisés cuando sacó a los israelitas de Egipto, nosotros podemos ser motivados por nuestra fe, nuestra profunda creencia que nos permite aferrarnos a nuestro propósito con una lealtad firme, como “si estuviera viendo al Invisible” (ver Hebreos 11:27). Lo que no es de fe es pecado (ver Romanos 14:23); por tanto, que todo lo que hagamos sea hecho por fe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e303027"
    }
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("4. Ser una bendición.")]), _vm._v(" Dios le dijo a Abraham que Él le bendeciría y le haría una bendición (ver Génesis 12:2). Yo creo que un deseo de ser una bendición es un estupendo motivador, y uno que agrada mucho a Dios. Me encanta poner sonrisas en los rostros. La Biblia dice que Jesús iba haciendo el bien (ver Hechos 10:38). ¡Esforcémonos por ser como Él!")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e305828"
    }
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("5. Por causa de la justicia.")]), _vm._v(" Yo creo que un buen factor motivador es sencillamente hacer algo porque es lo correcto. Jesús le dijo a Juan que lo bautizara a fin de cumplir con toda justicia (ver Mateo 3:15); lo hizo porque era lo correcto. Hay veces en la vida en que “la obligación” debe ser nuestro motivador. El apóstol Pablo nos recuerda que es nuestra obligación ocuparnos de nuestros padres y abuelos ancianos (ver 1 Timoteo 5:4). Los ancianos son frecuentemente ignorados simplemente porque los miembros de su familia no cumplen con su obligación. Yo creo que hacer algo porque es nuestra obligación es un motivo que Dios acepta.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e309428"
    }
  }, [_c('b', {
    staticClass: "calibre3"
  }, [_vm._v("6. La Palabra de Dios.")]), _vm._v(" Ser obediente a la Palabra de Dios es uno de los mejores motivadores que conozco. No tenemos que sentirnos con ganas de hacer algo, o pensar que es justo o si queremos o no hacerlo. Pero si estamos dispuestos a hacer lo que Dios dice que hagamos en su Palabra, Dios se agradará de nuestros motivos y no perderemos nuestra recompensa.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e311828"
    }
  }, [_vm._v("Una vez más te insto a que conozcas tu propósito y tus motivos. ¿Qué o quién te motiva? ¿Una pasión por servir a Dios, o un deseo de que te vean? No tengas temor a responder a este tipo de preguntas con sinceridad. ¡La verdad te hará libre! Puedo asegurarte que no eres diferente a los demás. Aun si descubres que algunos de tus motivos son impuros, no estás solo; eres sencillamente una de las personas valientes que están dispuestas a afrontar la realidad y realizar los cambios que necesites. Mantener nuestros motivos puros es un proceso de toda la vida que debe buscarse con pasión. Es muy fácil engañarse a uno mismo, así que comprometámonos a examinar regularmente nuestros motivos delante de Dios, pidiéndole que revele cualquier motivo incorrecto que tengamos.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e316929"
    }
  }, [_vm._v("Pasión con pureza")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e317429"
    }
  }, [_vm._v("La Biblia nos dice en Mateo 5:8 que quienes son puros de corazón verán a Dios. Yo creo que eso significa que las personas con corazones puros tienen una clara conciencia y entendimiento que Dios les da; ellos le oyen con gran claridad y tienen confianza en su voluntad.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e318829"
    }
  }, [_vm._v("Si hablas con un ingeniero sabrás que la única manera en que el metal puede utilizarse con seguridad es después de haberlo probado repetidamente bajo estándares y requisitos muy elevados. El metal que desea utilizarse debe ser puro, y a fin de que sea puro, tiene que pasar por el fuego: debe ser fundido y luego moldeado. Antes de poder cumplir nuestro propósito, debemos estar dispuestos a ser probados bajo los estándares de Dios y purificados para estar listos para ser usados.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e321629"
    }
  }, [_vm._v("Puede que hayas comenzado a leer este libro porque quieres saber cuál es tu propósito en la vida, y creo que lo encontrarás. Sin embargo, es vital que sepas cuál es la intención de tu corazón antes de poder entender y comprender el resto de lo que Dios tiene para ti.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e323129"
    }
  }, [_vm._v("La Biblia nos enseña cuál es la voluntad general de Dios para todas las personas. Algunas de esas cosas ya las hemos mencionado. El propósito de Dios es que disfrutemos de Él, le obedezcamos, disfrutemos de la vida, vivamos con pasión, y le representemos bien. Esas cosas son las mismas para todos; pero hay otras cosas específicas para cada individuo. Dios nos da a cada uno dones, talentos y capacidades únicas. A uno le es dada la capacidad de administrar (ver Romanos 12:6–8); otra persona podría tener la capacidad de enseñar y guiar, otra tiene la capacidad de cantar o pintar, y la lista sigue y sigue. Juntos formamos lo que la Biblia denomina el Cuerpo de Cristo. Él es nuestra cabeza y nosotros somos su cuerpo. Él guía y nosotros seguimos. Debemos entrenarnos a nosotros mismos para mantener puros nuestros motivos y seguir la voluntad de Dios en todo momento.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e327729"
    }
  }, [_vm._v("¿Te has entrenado alguna vez para algo intenso? ¿Quizá para una carrera de 5 kilómetros o hasta para una maratón? ¿Y si fueras a comenzar esa carrera sin haber siquiera trabajado para desarrollar esos músculos? ¿Y si, por el contrario, estuvieras todo el día sentado comiendo comida chatarra? Una vez que estés en la carrera—por mucho que tu mente quisiera impulsar a tu cuerpo a trabajar—, si esos músculos tuyos no están entrenados, no te va a ir bien. Lo mismo sucede con nuestra relación con Dios. Escogemos practicar el hacer lo que es correcto, y a medida que lo hacemos una y otra vez, formamos buenos hábitos que se convierten en parte de nuestro carácter. Nos convertimos en personas bien entrenadas para los propósitos de Dios.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e333630"
    }
  }, [_vm._v("Cuando trabajamos juntos colectivamente, su voluntad y su propósito se cumplen en la tierra. Por eso es tan importante entender por qué hacemos lo que hacemos y asegurarnos de que nuestros motivos sean puros, porque nuestro propósito definitivo es servir al propósito de Dios... y no al nuestro.")]), _vm._v(" "), _c('p', {
    staticClass: "h1",
    attrs: {
      "id": "d7e335630"
    }
  }, [_vm._v("Dale todo lo que tienes")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e336130"
    }
  }, [_vm._v("La Palabra de Dios nos da sencillas instrucciones con respecto al modo en que debemos manejar nuestras habilidades únicas y singulares; simplemente dice que te entregues a tus habilidades (ver 1 Timoteo 4:15). Para mí, eso significa que deberíamos mantenernos ocupados haciendo lo que es bueno y no tratando de hacer aquello para lo que no somos buenos o que somos incapaces de hacer. Muchas personas tratan de hacer aquello para lo cual otra persona es buena en lugar de hacer aquello para lo que ellos son buenos. Se comparan y compiten, y pierden su gozo en el proceso.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e339130"
    }
  }, [_vm._v("La Biblia dice:")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e339930"
    }
  }, [_vm._v("“Si es el de prestar un servicio, que lo preste; si es el de enseñar, que enseñe; si es el de animar a otros, que los anime; si es el de socorrer a los necesitados, que dé con generosidad; si es el de dirigir, que dirija con esmero; si es el de mostrar compasión, que lo haga con alegría.”")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e341730"
    }
  }, [_vm._v("—ROMANOS 12:7–8")]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "d7e342631"
    }
  }, [_vm._v("Puede que los años arruguen tu piel, pero perder el entusiasmo arruga tu alma.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e343631"
    }
  }, [_vm._v("No sólo necesitamos encontrar el propósito de Dios y realizarlo con motivos correctos, sino que también debemos hacerlo con pasión, celo y entusiasmo. Puede que los años arruguen tu piel, pero perder el entusiasmo arruga tu alma; te seca por dentro y todo se siente muerto. Dios no quiere que le obedezcamos meramente por obligación; Él quiere que le sirvamos porque lo deseamos y que disfrutemos plenamente de Él. Tratar de servir a Dios por obligación sin que a la vez haya un deleite en Él es realmente un insulto. No somos marionetas, somos personas creadas por Dios con libre albedrío; Él nos ha escogido y quiere que nosotros lo escojamos a Él con alegría.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e347231"
    }
  }, [_vm._v("Recuerdo la boda, en Juan capítulo 2, en la que la madre de Jesús le pide ayuda cuando se descubre que se ha acabado el vino. Él les dice a los sirvientes que agarren seis tinajas grandes y las llenen de agua. Me pregunto lo que los sirvientes pensaron de esas instrucciones, sabiendo que su amo corría el riesgo de quedar avergonzado delante de sus invitados, y en ese momento aquel hombre llamado Jesús les estaba pidiendo que llenaran las tinajas de agua. Pero no parece que le cuestionaran; de hecho, la Biblia dice que ellos llenaron esas tinajas “hasta el borde” (Juan 2:7). De inmediato, el agua se convirtió en vino.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e350631"
    }
  }, [_vm._v("Este fue el primer milagro registrado del ministerio de Jesús en la tierra, y quiero recordarte que sus milagros no cesaron en ese punto. Él hará también milagros en tu vida si le obedeces y te entregas como una vasija limpia que Él pueda llenar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e352331"
    }
  }, [_vm._v("Al igual que Jesús trabajó en colaboración con los sirvientes para convertir el agua en vino, trabaja en colaboración con nosotros hoy día. Siento pasión que se aviva en mi alma cuando me recuerdo a mí misma que estoy trabajando en colaboración con el Dios todopoderoso, omnisciente y omnipresente. Sólo piensa en ello… ¡tú eres colaborador de Dios!")]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "d7e354932"
    }
  }, [_vm._v("Al igual que Jesús trabajó en colaboración con los sirvientes para convertir el agua en vino, trabaja en colaboración con nosotros hoy día.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e356232"
    }
  }, [_vm._v("Nada nos vigoriza más que tener una visión clara de lo que debemos estar haciendo. Tenemos que trabajar a fin de sobrevivir, pero el trabajo sin propósito nos agota. El mundo está lleno de personas cansadas y agotadas, y en su mayor parte se debe a que la gente “se mueve por inercia” en la vida; sin embargo, no ha encontrado su propósito. Pasan sus vidas haciendo lo que odian y no son lo bastante valientes para hacer lo que realmente quieren hacer. Tristemente, uno de los mayores motivadores para la gente es con frecuencia el salario que reciben. Te iría mejor si ganases menos dinero y estuvieras apasionado por lo que haces que ganar mucho dinero y estar haciendo algo que desprecias. ¿Te atreves seguir tu corazón a lo largo de todo el camino hasta sentirte realizado?")]), _vm._v(" "), _c('p', {
    staticClass: "extb",
    attrs: {
      "id": "d7e360832"
    }
  }, [_vm._v("¿Te atreves seguir tu corazón a lo largo de todo el camino hasta sentirte realizado?")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e362032"
    }
  }, [_vm._v("La eternidad sobrepasará con mucho cualquier periodo de tiempo que pasemos en esta tierra, así que deberíamos aprovechar al máximo los años que tenemos y comprender que lo que hacemos hoy, y en especial el “porqué” lo hacemos, nos afecta no sólo ahora, sino también más adelante. El aquí y el después. Tener pasión significa sentir, arriesgarse, soñar y vivir. Solamente tenemos una vida que vivir; no la desperdiciemos.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-458ea1f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Meye_9781621369127_epub_c7_r1.vue
// module id = 75
// module chunks = 0